import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import intl from "components/i18n/ReactIntlWrapper";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button } from "@mui/material";
import CountrySelect from "../../common/Selects/CountrySelect";
import RequestSelect from "../Request/RequestSelect";
import TimeOffSearchBar from "../TimeOffSearchBar";
import { PermissionsGate } from "../../authorization/PermissionsGate";
import { ENTITY_TYPE } from "common/constants";
import RequestStatusSelect from "../Request/RequestStatusSelect";
import { useWorkflow } from "components/Workflow/WorkflowContext";

const HRCalendarNavbar = ({
  handleCountryChange,
  selectedCountry,
  countries,
  input,
  nonWorkingDay,
  requestType,
  onSearch,
  HRView,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [idRequest, setIdRequest] = useState(null);
  const [idStatus, setIdStatus] = useState(null);
  const [queryString, setQueryString] = useState<string>("");
  const [workflowLabelKeys, setWorkflowLabelKeys] = useState(null);
  const { workflow } = useWorkflow();

  useEffect(() => {
    setWorkflowLabelKeys(
      workflow?.states?.map((state) => ({
        label: state.labelKey,
        id: state.id,
      }))
    );
  }, [workflow]);
  const handleSearchButton = () => {
    onSearch(queryString, idStatus, idRequest);
  };

  const handleRequestChange = (e) => {
    if (e !== null) {
      setIdRequest(e.id);
    } else {
      setIdRequest(null);
    }
  };

  const handleStatusChange = (e) => {
    if (e !== null) {
      setIdStatus(e.id);
    } else {
      setIdStatus(null);
    }
  };

  const handleAddHoliday = () => {
    navigate('/Calendar/Holidays/new', { state: { from: location.pathname } });
  };

  return (
    <Box
      component="nav"
      className={
        nonWorkingDay
          ? "container-fluid mb-5"
          : "container-fluid filters gap-3 mb-5"
      }
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      gap={2}
    >
      {nonWorkingDay ? (
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mb={2} width={'100%'}>
          <Box sx={{ width: '300px' }}>
            <CountrySelect
              handleCountryChange={handleCountryChange}
              selectedCountry={selectedCountry}
              countries={countries}
              inputCountry={input.country.name}
              isClearable={true}
            />
          </Box>
          <PermissionsGate
            identifier="ui.timeoff.calendar.nonworkingday-buttons"
            entityType={ENTITY_TYPE.EMPLOYEE}
            viewRoles={[]}
            editRoles={[]}
          >
            <Box sx={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddHoliday}
                sx={{ height: 40 }}
              >
                <AddIcon /> {intl.get('holiday.new') ? intl.get('holiday.new') : intl.get('button.new')}
              </Button>
            </Box>
          </PermissionsGate>
        </Box>
      ) : (
        <>
          {HRView && (
            <PermissionsGate
              identifier="ui.timeoff.calendar.rrhh-button"
              entityType={ENTITY_TYPE.EMPLOYEE}
              viewRoles={[]}
              editRoles={[]}
            >
              <TimeOffSearchBar
                queryString={queryString}
                setQueryString={setQueryString}
              />
            </PermissionsGate>
          )}
          <RequestSelect
            requestType={requestType}
            selectedRequest={idRequest}
            handleRequestChange={handleRequestChange}
          />
          <RequestStatusSelect
            requestStatus={workflowLabelKeys}
            selectedStatus={idStatus}
            handleStatusChange={handleStatusChange}
            isClearable={true}
          />
          <Button
            variant="outlined"
            color="primary"
            startIcon={<SearchIcon />}
            onClick={handleSearchButton}
          >
            {intl.get("jiraIssueSearch.search.button")}
          </Button>
        </>
      )}
    </Box>
  );
};

export default HRCalendarNavbar;
